import * as React from 'react';
import * as _ from 'lodash';
import * as Model from '../../api/model';
import { Grid, CircularProgress, Paper, Table, TableHead, TableRow, TableCell, TableBody, Toolbar, Typography, Tooltip, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ClassificationEditItem from './ClassificationEditItem';
import ClassificationAddItem from './ClassificationAddItem';
import { API } from '../../api';

//#region UI configuration
const strings = {
    title: 'Classifications',
    addButton: 'Add',
    idColumn: 'Id',
    nameColumn: 'Name'
};
//#endregion

//#region Props & State
interface ClassificationsPageProps { }
interface ClassificationsPageState {
    loading: boolean;
    items: Model.Classification[];
    selected: null | number;
    add: boolean;
}

const initialState: ClassificationsPageState = {
    loading: true,
    items: [],
    selected: null,
    add: false
};
//#endregion

class ClassificationsPage extends React.Component<ClassificationsPageProps, ClassificationsPageState> {

    constructor(props: ClassificationsPageProps) {
        super(props);

        this.state = initialState;
    }

    // #region Lifecycle
    componentDidMount(): void {
        API.classification.list().then(items => {
            this.setState({ loading: false, items });
        });
    }

    render() {
        const { loading, items, selected, add } = this.state;

        return (
            <React.Fragment>
                {loading && <Grid container={true} justify="center">
                    <CircularProgress />
                </Grid>}

                {!loading && <Paper>
                    <Toolbar>
                        <Grid container={true} justify="space-between" alignItems="center">
                            <Grid item={true}>
                                <Typography variant="title">{strings.title}</Typography>
                            </Grid>
                            <Grid item={true}>
                                <Tooltip title={strings.addButton}>
                                    <IconButton onClick={this.onAddClick}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Toolbar>

                    <Table>
                        <colgroup>
                            <col width="15%" />
                            <col width="80%" />
                            <col width="5%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell numeric={true}>{strings.idColumn}</TableCell>
                                <TableCell>{strings.nameColumn}</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {add && <ClassificationAddItem onItemAdded={this.onItemAdded} onCancelItemAdd={this.onCancelItemAdd} />}
                            {items.map(item => (
                                <ClassificationEditItem
                                    key={item.id}
                                    item={item}
                                    selected={selected === item.id}
                                    onItemSelected={this.onItemClick}
                                    onItemEdited={this.onItemEdited}
                                    onItemRemoved={this.onItemRemoved}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </Paper>}
            </React.Fragment>
        );
    }
    // #endregion

    // #region Private
    private onAddClick = () => {
        this.setState({ add: true });
    }

    private onItemClick = (id: number) => {
        const { selected } = this.state;
        if (selected !== id) {
            this.setState({ selected: id });
        } else {
            this.setState({ selected: null });
        }
    }

    private onItemRemoved = (id: number) => {
        const { items } = this.state;
        this.setState({ items: items.filter(value => value.id !== id) });
    }

    private onItemEdited = (model: Model.Classification) => {
        let { items } = this.state;

        items = items.map(item => {
            if (item.id === model.id) {
                return model;
            } else {
                return item;
            }
        });

        items = _.sortBy(items, [(o: Model.Classification) => (o.name)]);

        this.setState({ items, selected: null });
    }

    private onItemAdded = (model: Model.Classification) => {
        let { items } = this.state;
        items = items.concat(model);
        items = _.sortBy(items, [(o: Model.Classification) => (o.name)]);
        this.setState({ items, add: false });
    }

    private onCancelItemAdd = () => {
        this.setState({ add: false });
    }
    // #endregion
}

export default ClassificationsPage;



// WEBPACK FOOTER //
// ./src/modules/classification/ClassificationsPage.tsx